import { Lifecycle } from '@dap/memberadmin/types';
import { useMemo } from 'react';
import { useMemberadminTFunction } from './useMemberadminTranslation';

export const useLifecycleLabels = (): Record<Lifecycle, string> => {
  const t = useMemberadminTFunction();
  return useMemo(
    () => ({
      [Lifecycle.ACTIVE]: t('memberadmin.filter.status.active'),
      [Lifecycle.DRAFT]: t('memberadmin.filter.status.draft'),
      [Lifecycle.PENDING]: t('memberadmin.filter.status.pending'),
      [Lifecycle.SUSPENDED]: t('memberadmin.filter.status.suspended'),
      [Lifecycle.DEACTIVATED]: t('memberadmin.filter.status.deactivated'),
    }),
    [t]
  );
};
